import { Grid, Typography } from '@material-ui/core'
import { alpha } from '@material-ui/core/styles'
import styled from 'styled-components'
import { irem } from '../../utils'
import { Button } from '../button/button'

export const StyledWrapper = styled.div`
  width: 100%;
  margin: auto;
  position: relative;

  ${props => props.theme.breakpoints.up('lg')} {
    max-width: ${props => props.theme.typography.pxToRem(1250)};
  }

  &::before {
    content: '';
    height: ${props => props.theme.typography.pxToRem(8)};
    width: 100%;
    border-radius: ${props => props.theme.typography.pxToRem(12)} ${props => props.theme.typography.pxToRem(12)} 0 0;
    background: linear-gradient(90deg, #eba719 0%, #e37025 100%);
    position: absolute;
    top: 0;
    left: 0;
    z-index: 2;
  }
`

export const StyledImageBackground = styled.div`
  width: 100%;
  filter: drop-shadow(0 ${props => props.theme.typography.pxToRem(3)} ${props => props.theme.typography.pxToRem(15)} ${props => alpha(props.theme.palette.text.secondary, 0.19)});
  position: relative;
  padding: 0;
  z-index: 1;
  background: transparent;
  -webkit-transform: translate3d(0, 0, 0);
`

export const StyledTrapezoid = styled.div`
  width: 100%;
  z-index: 10;
  background: ${props => props.theme.palette.common.white};
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  padding: ${irem(32)} ${irem(38)};
  border-radius: ${props => props.theme.typography.pxToRem(12)};

  ${props => props.theme.breakpoints.up('sm')} {
    flex-direction: row;
    padding: ${irem(80)} ${irem(85)};
    align-items: center;
  }

  ${props => props.theme.breakpoints.up('md')} {
    flex-direction: row;
    align-items: center;
    gap: 0 ${props => props.theme.typography.pxToRem(120)};
    padding: ${irem(51)} ${irem(63)} ${irem(36)} ${irem(63)};
    min-height: ${props => props.theme.typography.pxToRem(200)};
  }
`

export const StyledDoubleTriangle = styled.div`
  position: absolute;
  bottom: ${props => props.theme.typography.pxToRem(-6)};
  right: ${props => props.theme.typography.pxToRem(-6)};
`

export const StyledHorizontalHeadingSection = styled(Grid)`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
`

export const StyledVerticalHeadingSection = styled(Grid)`
  width: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
`

export const StyledVerticalCtaSection = styled(Grid)`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;

  ${props => props.theme.breakpoints.up('md')} {
    max-width: 20%;
    flex-basis: 20%;
    align-items: flex-end;
  }
`

export const StyledTitle = styled(Typography)`
  font-weight: 700;
  color: ${props => props.theme.palette.secondary.dark};
  font-size: ${props => props.theme.typography.pxToRem(24)};
  line-height: ${props => props.theme.typography.pxToRem(30)};
  margin-bottom: ${props => props.theme.typography.pxToRem(8)};
  font-style: italic;

  ${props => props.theme.breakpoints.up('sm')} {
    font-size: ${props => props.theme.typography.pxToRem(24)};
    line-height: ${props => props.theme.typography.pxToRem(30)};
    margin-bottom: ${props => props.theme.typography.pxToRem(15)};
  }

  ${props => props.theme.breakpoints.up('md')} {
    margin-bottom: ${props => props.theme.typography.pxToRem(0)};
  }
`

export const StyledSubtitle = styled(Typography)`
  line-height: ${props => props.theme.typography.pxToRem(30)};
  font-size: ${props => props.theme.typography.pxToRem(18)};
  margin-bottom: ${props => props.theme.typography.pxToRem(16)} !important;
  color: ${props => props.theme.palette.text.primary};
  font-weight: 500;

  ${props => props.theme.breakpoints.up('sm')} {
    font-size: ${props => props.theme.typography.pxToRem(17)};
    margin-bottom: ${props => props.theme.typography.pxToRem(22)};
  }

  ${props => props.theme.breakpoints.up('md')} {
    font-size: ${props => props.theme.typography.pxToRem(17)};
    margin-bottom: 0;
  }
`

export const StyledContent = styled(Typography)`
  font-size: ${props => props.theme.typography.pxToRem(15)};
  line-height: ${props => props.theme.typography.pxToRem(28)};
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  margin-bottom: ${props => props.theme.typography.pxToRem(15)} !important;

  ${props => props.theme.breakpoints.up('md')} {
    font-size: ${props => props.theme.typography.pxToRem(17)};
    line-height: ${props => props.theme.typography.pxToRem(28)};
    margin-top: ${props => props.theme.typography.pxToRem(10)};
    margin-bottom: 0 !important;
  }
`

export const StyledButton = styled(Button)`
  font-size: ${props => props.theme.typography.pxToRem(16)};

  ${props => props.theme.breakpoints.up('xs')} {
    padding: ${props => props.theme.typography.pxToRem(16)} ${props => props.theme.typography.pxToRem(10)};
  }

  ${props => props.theme.breakpoints.up('md')} {
    font-size: ${props => props.theme.typography.pxToRem(18)};
    min-height: ${props => props.theme.typography.pxToRem(51)};
    min-width: ${props => props.theme.typography.pxToRem(124)};
    margin-top: 0;
  }
`

export const StyledButtonContainer = styled(Grid) <{ $extra?: boolean }>`
  margin: 0;
  width: 100%;
  margin-top: ${props => props.theme.typography.pxToRem(0)};
  display: flex;
  align-items: end;
  justify-content: flex-start;
  padding-bottom: ${props => props.$extra ? props.theme.typography.pxToRem(25) : 0};

  > a {
    text-decoration: none;
  }

  ${props => props.theme.breakpoints.up('sm')} {
    margin-top: unset;
    justify-content: center;
  }

  ${props => props.theme.breakpoints.up('md')} {
    max-width: 20%;
  }
`

export const StyledCtaInnerWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-around;

  ${props => props.theme.breakpoints.up('md')} {
    flex-direction: row;
  }
`